import React from 'react'
import { BsLinkedin, BsInstagram } from 'react-icons/bs';
import {  FaGithub } from 'react-icons/fa';

const SocialMedia = () => (
    <div className="app__social">
      <div>
       <a href='https://www.linkedin.com/in/danyal-akhtar-02ba40168' target='_blank' ><BsLinkedin /></a> 
      </div>
      <div>
       <a href='https://github.com/Danyal0786' target='_blank'> <FaGithub /></a>
      </div>
      <div>
       <a href='https://www.instagram.com/mrdecent06/'target='_blank' ><BsInstagram /></a> 
      </div>
    </div>
  );

export default SocialMedia